import {
    VLPOption,
    SelectedOption,
    VLPVariant,
    isColorOption,
} from '@storefronts/common-types'
import { VariantOption } from './VariantOption'

interface VariantGroupProps {
    option: VLPOption
    currentSelection?: SelectedOption
    isAvailable: (value: string) => boolean
    onSelect: (value: string) => void
    getMatchingVariant: (value: string) => VLPVariant | undefined
    showVariantImagesAsColors?: boolean
}

export const VariantGroup: React.FC<VariantGroupProps> = ({
    option,
    currentSelection,
    isAvailable,
    onSelect,
    getMatchingVariant,
    showVariantImagesAsColors,
}) => {
    const isColor = isColorOption(option)

    return (
        <div>
            <div className="mb-2 text-sm font-medium">
                {option.name}
                {currentSelection?.value && (
                    <span className="text-muted-foreground">
                        : {currentSelection.value}
                    </span>
                )}
            </div>
            <div className="flex flex-wrap items-center gap-2">
                {option.values.map(({ value, color, image }, index: number) => (
                    <VariantOption
                        key={`${option.name}-${value}-${index}`}
                        value={value}
                        isSelected={currentSelection?.value === value}
                        isAvailable={isAvailable(value)}
                        onClick={() => onSelect(value)}
                        type={
                            isColor
                                ? 'color'
                                : option.values.some(
                                        (v) => v.image !== undefined,
                                    )
                                  ? 'image'
                                  : 'text'
                        }
                        color={color}
                        imageUrl={image}
                        variant={getMatchingVariant(value)}
                        showVariantImagesAsColors={showVariantImagesAsColors}
                    />
                ))}
            </div>
        </div>
    )
}
